export const createDefaultState = () => ({
    name: '',
    display: '',
    sort_order: 1,
});
